var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputCircle = function SvgInputCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "input_circle_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.123.482h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#input_circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.123 12.307v9.175q0 .424.287.712.288.288.713.288.424 0 .712-.288a.97.97 0 0 0 .288-.712v-9.175l1.9 1.875q.274.275.687.287a.93.93 0 0 0 .713-.287.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7l-3.6-3.6a.96.96 0 0 0-.7-.3q-.4 0-.7.3l-3.6 3.6a.98.98 0 0 0-.288.687.93.93 0 0 0 .288.713.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275zm1-7.825q-3.35 0-5.675 2.325t-2.325 5.675q0 .825.162 1.625.163.8.488 1.55.175.424.112.85-.062.425-.387.75-.3.3-.738.137-.437-.162-.662-.637a11 11 0 0 1-.725-2.088 9.5 9.5 0 0 1-.25-2.187q0-2.076.787-3.9a10.1 10.1 0 0 1 2.138-3.175q1.35-1.35 3.175-2.138a9.7 9.7 0 0 1 3.9-.787q2.075 0 3.9.787a10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9q0 1.125-.238 2.212a9.4 9.4 0 0 1-.737 2.113q-.225.45-.663.6-.437.15-.737-.15t-.388-.725a1.34 1.34 0 0 1 .088-.825 7.4 7.4 0 0 0 .512-1.588 8.3 8.3 0 0 0 .163-1.637q0-3.35-2.325-5.675t-5.675-2.325"
  }))));
};
export default SvgInputCircle;